export default {
  title: "RH Restaurants Main",
  type: "rh/components/content/rh-restaurants-main",
  isContainer: false,
  config: {
    emptyLabel: "RH Restaurants Main",
    isEmpty: () => false
  }
};
